<dx-tabs
  class="field-editor-sidebar-tabs"
  [dataSource]="tabs"
  [selectedIndex]="selectedIndex"
  (onItemClick)="selectTab($event)"
></dx-tabs>
<dx-scroll-view width="100%">
  <dx-list [dataSource]="ds"
           class="fields-crop-list"
           [focusStateEnabled]="false"
           (onItemClick)="itemClick($event)"
           itemTemplate="listItem">
    <div *dxTemplate="let data of 'listItem';">
      <div class="flex flex-row w-full">

        <div class="m-2">
          <span class="text-gray-700 text-sm block font-normal mb-1">{{data.name}}</span>
          <div class="flex items-center text-xs text-gray-500">
            <p>{{data.name}}</p>
            <p class="px-1">•</p>
            <!--<p>{{data.time | date:'yyyy-MM-dd HH:mm:ss'}}</p>-->
          </div>
        </div>

        <div #item class="text-center m-2 ml-auto self-center">
          <dx-button icon="more"></dx-button>
          <dx-context-menu
            [dataSource]="[{id: data.id, text: 'Marquer comme lu', action: 'read', icon:'read'}]"
            [width]="100"
            showEvent="click"
            (onItemClick)="contextMenuClick($event)"
            [target]="item">
            <div class="text-gray-700 text-sm" *dxTemplate="let m of 'item'; let i = index">
              <span class="ml-2">{{m.text}}</span>
            </div>
          </dx-context-menu>
        </div>

      </div>
    </div>
  </dx-list>
</dx-scroll-view>
